import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import { Text } from '@famly/mf_data-display_text';
import { Box } from '@famly/mf_layout_box';
import * as ChildSelectors from 'signin-app/child/selectors';
import translate from 'signin-app/helpers/translate';
import Header from 'signin-app/components/header';
import { fetchGoHomeWithChildren } from 'signin-app/go-home-with/actions';
import Groups from 'signin-app/go-home-with/groups';
import Children from 'signin-app/go-home-with/children';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { PageContainer } from 'signin-app/components/containers';
import { Spinner } from '@famly/mf_feedback_spinner';
import { Stack } from '@famly/mf_layout_stack';
import * as Selectors from './selectors';
const GoHomeWith = (props) => {
    const { match } = props;
    const isFetching = useTypedSelector(Selectors.isFetching);
    const childName = useTypedSelector(state => ChildSelectors.childName(state, { id: match.params.childId, childId: match.params.childId }));
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(fetchGoHomeWithChildren.action(props.match.params.childId));
    }, [dispatch, props.match.params.childId]);
    const title = (_jsx(Text, { variant: "h6", emphasized: true, color: "n400", textAlign: "center", my: 6, "data-e2e-id": "go-home-with-title", children: translate('withWhomIsGoingHome', { childName }) }));
    return (_jsxs(PageContainer, { "data-e2e-id": "go-home-with-screen", children: [_jsx(Header, { centerElement: title }), !isFetching ? (_jsxs(Box, { children: [_jsx(Route, { path: match.url, exact: true, component: Groups }), _jsx(Route, { path: `${match.url}/:groupId`, render: props => _jsx(Children, { ...props, childId: match.params.childId }) })] })) : (_jsx(Stack, { justifyContent: "center", width: "100%", children: _jsx(Spinner, { size: 32, "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) }))] }));
};
export default GoHomeWith;
